"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _core = require("@material-ui/core");

var _Icon = _interopRequireDefault(require("./Icon"));

var _jsxRuntime = require("react/jsx-runtime");

var style = (0, _core.makeStyles)(function (theme) {
  return {
    closeButton: {
      cursor: 'pointer'
    },
    content: {
      paddingBottom: theme.spacing(2)
    }
  };
});

function DialogModal(props) {
  var classes = style();
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_core.Dialog, {
    onClose: props.onClose,
    open: props.isOpen,
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_core.DialogTitle, {
      disableTypography: true,
      children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        className: "d-flex align-items-center justify-content-between",
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("h2", {
          className: "m-0",
          children: props.title
        }), props.showCloseButton && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          className: classes.closeButton,
          "aria-label": "close",
          onClick: props.onClose,
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Icon.default, {
            icon: "cross",
            size: 16
          })
        })]
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_core.DialogContent, {
      classes: {
        root: classes.content
      },
      children: props.children
    })]
  });
}

DialogModal.defaultProps = {
  showCloseButton: false
};
DialogModal.propTypes = {
  isOpen: _propTypes.default.bool.isRequired,
  onClose: _propTypes.default.func.isRequired,
  title: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.node), _propTypes.default.node]).isRequired,
  children: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.node), _propTypes.default.node]).isRequired,
  showCloseButton: _propTypes.default.bool
};
var _default = DialogModal;
exports.default = _default;
//# sourceMappingURL=DialogModal.js.map